import { EOrderDeliveryExpeditionType } from './EOrderDeliveryExpeditionType'
import { EOrderShippingOperator } from './EOrderShippingOperator'

export enum EOrderDeliveryStatus {
  //pre-accepted
  Processing = 'processing',
  WaitingBiding = 'waiting_biding',
  WaitingHub = 'waiting_hub',
  Refused = 'refused',
  Ignored = 'ignored',

  //picking
  WaitingOrder = 'waiting_order',
  WaitingGroup = 'waiting_group',
  SearchingCourier = 'searching_courier',
  CourierNotFound = 'courier_not_found',
  CourierFound = 'courier_found',
  PickingUp = 'picking_up',

  //delivering
  Delivering = 'delivering',
  Delivered = 'delivered',
  FailedToDelivery = 'failed_to_delivery',
  Canceled = 'canceled',
  Lost = 'lost',
}

export const orderDeliveryStatusLabels = (
  status: EOrderDeliveryStatus,
  expeditionType: EOrderDeliveryExpeditionType,
  shippingOperator: EOrderShippingOperator,
  has_invoice: boolean,
  packed: boolean,
) => {
  const isExpeditionDropOff = [EOrderDeliveryExpeditionType.DropOff].includes(expeditionType)
  const isOrderNeedsInvoice =
    isExpeditionDropOff || [EOrderShippingOperator.Intelipost].includes(shippingOperator)

  const labelObj = {
    //pre-accepted
    [EOrderDeliveryStatus.Processing]: 'Processando',
    [EOrderDeliveryStatus.WaitingBiding]: 'Aguardando Horário do Leilão',
    [EOrderDeliveryStatus.WaitingHub]: 'Aguardando Hub',
    [EOrderDeliveryStatus.Refused]: 'Recusado',
    [EOrderDeliveryStatus.Ignored]: 'Ignorado',

    //picking
    [EOrderDeliveryStatus.WaitingOrder]:
      isOrderNeedsInvoice && !has_invoice
        ? 'Aguardando Nota Fiscal'
        : !packed
          ? 'Aguardando Separação'
          : `Aguardando ${isExpeditionDropOff ? 'Envio' : 'Coleta'}`,
    [EOrderDeliveryStatus.WaitingGroup]:
      isOrderNeedsInvoice && !has_invoice
        ? 'Aguardando Nota Fiscal'
        : !packed
          ? 'Aguardando Separação'
          : `Aguardando ${isExpeditionDropOff ? 'Envio' : 'Coleta'}`,
    [EOrderDeliveryStatus.SearchingCourier]:
      isOrderNeedsInvoice && !has_invoice
        ? 'Aguardando Nota Fiscal'
        : !packed
          ? 'Aguardando Separação'
          : 'Buscando motorista',
    [EOrderDeliveryStatus.CourierNotFound]:
      isOrderNeedsInvoice && !has_invoice
        ? 'Aguardando Nota Fiscal'
        : !packed
          ? 'Aguardando Separação'
          : 'Motorista não encontrado',
    [EOrderDeliveryStatus.CourierFound]:
      isOrderNeedsInvoice && !has_invoice
        ? 'Aguardando Nota Fiscal'
        : !packed
          ? 'Aguardando Separação'
          : 'Motorista encontrado',
    [EOrderDeliveryStatus.PickingUp]:
      isOrderNeedsInvoice && !has_invoice
        ? 'Aguardando Nota Fiscal'
        : !packed
          ? 'Aguardando Separação'
          : 'Motorista indo para coleta',

    //delivering
    [EOrderDeliveryStatus.Delivering]:
      isOrderNeedsInvoice && !has_invoice
        ? 'Aguardando Nota Fiscal'
        : !packed
          ? 'Aguardando Separação'
          : 'Em trânsito para entrega',
    [EOrderDeliveryStatus.Delivered]: 'Entregue',
    [EOrderDeliveryStatus.Canceled]: 'Cancelado',
    [EOrderDeliveryStatus.FailedToDelivery]: 'Falha na Entrega',
    [EOrderDeliveryStatus.Lost]: 'Extraviado',
  }

  return labelObj[status]
}
